/** @format */

export const fonts = {
	montserrat: "'Montserrat', sans-serif",
	robotoCondensed: "'Roboto Condensed', sans-serif",
};

export const fontSize = {
	small: "0.8rem",
	medium: "1.6rem",
	large: "2.4rem",
};

export const colors = {
	primary: "#040d45",
	mainSecondary: "#1ec195",
	secondary: "#000000",
	secondPrimary: "#023020", //dark green
	thirdPrimary: "#12343b", // night blue shadow
	blueRibbon: "#143AA2",
	white: "#ffffff",
	cancel: "#cc0000",
	persianRed: "#CA3433",
	headerColor: "#1ec195",
	navyBlue: "#20283E",
	darkGrey: "#484848",
	yellowGold: "#DBAE58",
	orangeWarning: "#ffb55a",
	lightGrey: "#cbd6e4",
	aquaBlue: "#8bd3c7",
	lightRed: "#e60049",
	mediumBlue: "#00b7c7",
	lightGreen: "#65B741",
	successGreen: "#007200",
	blue: "#0077b6",
	primaryBlue: "#42a5f5",
	infoDarkBlue: "#0288d1",
	mainPrimary: "#007a33", // main green color
	secondaryMain: "#ffcc00", // second main gold color
	darkGreen: "#004d00",
	lightGold: "#fff2e6",
	mediumGold: "#ffdb4d",
	warning: "rgb(165, 164, 160)",
	businessAccent: "#ffb300"
};

export const buttonColors = {
	primary: "#1ec195",
	secondary: "#000000",
	secondPrimary: "#023020", //dark green
	persianRed: "#CA3433",
	blueRibbon: "#143AA2",
	darkGreen: "#004d00",
	lightGreen: "#65B741",
	mediumGreen: "#789461",
	skyBlue: "#00a6fb",
	primaryBlue: "#42a5f5",
	primaryDark: "#000000",
	infoDarkBlue: "#0288d1",
	mainPrimary: "#007a33", // main green color
	secondaryMain: "#ffcc00", // second main gold color
	mainSecondary: "#1ec195",
};

export const typographyHeaderColor = {
	primary: "#1ec195",
	secondary: "#000000",
	white: "#FFFFFF",
};

export const gridSpacing = 3;
